import { IAuditNode } from '@alberta/konexi-shared';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { ModalController } from '@ionic/angular';
import { SwodocImage } from 'src/app/shared/models/swodoc/swodoc-image';
import { v4 } from 'uuid';

import { ATTACHMENT_LOCAL_PREFIX } from '@services/attachment/attachment-service.interface';
import { IAttachmentWithData } from '../../document-attachment.service';
import { DocumentEditService } from '../../document-edit.service';
import { SwodocNodeSignatureModal } from './modal/swodoc-node-signature.modal';

@Component({
  selector: 'swodoc-node-signature',
  templateUrl: 'swodoc-node-signature.html',
  styleUrls: ['swodoc-node-signature.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SwodocNodeSignature implements OnInit {
  @Input() node: IAuditNode;
  @Input() documentEditService: DocumentEditService;
  @Output() changed = new EventEmitter<IAuditNode>();
  @Output() imageAdded = new EventEmitter<SwodocImage>();

  public signatureImage: Partial<IAttachmentWithData>;

  constructor(
    private _modalCtrl: ModalController,
    private _changeDetetorRef: ChangeDetectorRef
  ) {}

  async ngOnInit() {
    const images = this.documentEditService
      .getImagesForNodeId(this.node.id)
      .sort((a: any, b: any) =>
        a?.metadata?.createdAt && b?.metadata?.createdAt
          ? new Date(a.metadata.createdAt).valueOf() - new Date(b.metadata.createdAt).valueOf()
          : 1
      );
    this.signatureImage = images[images.length - 1];
    this._changeDetetorRef.markForCheck();
  }

  async sign() {
    const signatureModal = await this._modalCtrl.create({
      component: SwodocNodeSignatureModal,
      backdropDismiss: false,
      cssClass: 'fullPageModal',
    });

    await signatureModal.present();
    const result = await signatureModal.onDidDismiss();
    const modalData = result.data;

    if (!modalData || !modalData.signature) {
      return;
    }

    if (this.signatureImage) {
      this.documentEditService.removeImage(this.signatureImage._id);
    }
    const signature = modalData.signature;
    const signatureId = `${ATTACHMENT_LOCAL_PREFIX}${v4()}`;
    const newImage = {
      _id: signatureId,
      metadata: {
        auditNodeId: this.node.id,
        type: 102, // SwodocSignature
      },
      data: signature,
    } as Partial<IAttachmentWithData>;
    this.signatureImage = newImage;
    this.documentEditService.addImage(newImage);
    this.changed.emit(this.node);
  }
}
